export const Name = 'show-loyalty-dialog';
export const ShowLoyaltyDialogEvent = Name;
//# sourceMappingURL=index.js.map